import o from "./ghl-ui.es804.js";
import t from "./ghl-ui.es805.js";
import a from "./ghl-ui.es806.js";
import r from "./ghl-ui.es807.js";
import e from "./ghl-ui.es808.js";
var m = {
  code: "de",
  formatDistance: o,
  formatLong: t,
  formatRelative: a,
  localize: r,
  match: e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const s = m;
export {
  s as default
};
